<button id="userMenu" mat-icon-button type="button" [matMenuTriggerFor]="userActions">
  <span class="relative flex items-center">
    <mat-icon svgIcon="user" />
  </span>
</button>

<mat-menu #userActions="matMenu" class="p-5 menu-user" [xPosition]="'before'">
  @if (user() !== undefined) {
    <div class="text-center text-primary text-h2 menu-name overflow-hidden text-ellipsis">
      {{ user()?.firstName }} {{ user()?.lastName }}
    </div>
    <div class="text-center text-grey-1 menu-email mb-4 mt-2 overflow-hidden text-ellipsis">
      {{ user()?.email }}
    </div>
  }
  @for (menu of menuUser; track menu.path) {
    <a class="menu-item mb-2" mat-menu-item [routerLink]="[menu.path]">
      @if (menu.menuIcon) {
        <mat-icon [svgIcon]="menu.menuIcon" />
      }
      <span [innerHTML]="menu.menuTitle | transloco"></span>
    </a>
  }
  <button class="menu-item menu-logout" mat-menu-item type="button" (click)="logout()">
    <mat-icon svgIcon="menu-logout" />
    <span>{{ 'menu.logout' | transloco }}</span>
  </button>
</mat-menu>
